import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import '../components/MaterialTableOverrides.less';
import './Index.less';
import useAPI from '../hooks/useAPI';

import { NavLink } from 'react-router-dom';
import { getFieldRenderFunction } from './index/Shared';

import { localization } from '../helpers/table';
import { tableIcons } from '../helpers';
import HideColumnButton from '../components/UI/HideColumnButton';

export default function Index(props) {
  const api = useAPI();
  const n = props.name;
  let d = props.data.sort((a,b) => {
    if((a.num.startsWith('М') || a.num.startsWith('M')) && !(b.num.startsWith('М') || b.num.startsWith('M'))) {
      return 1;
    }
    if((b.num.startsWith('М') || b.num.startsWith('M')) && !(a.num.startsWith('М') || a.num.startsWith('M'))) {
      return -1;
    }
    return 0;
  });


  const DEFAULT_YEAR = Number(DEFAULT_YEAR_WEBPACK);
  const years = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
  const types = [{ name: 'Базовая', num: 1 }, { name: 'Специальная', num: 2 }];

  const [currentPeriod, setCurrentPeriod] = useState();
  const [selectedType, setIsChecked] = useState([1, 2]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [show, setShow] = useState(false)
  // фильтр по части гранта нужен, если хотя бы один показатель,
  // у которого есть хотя бы одно значение, у которого fundingId не пустой
  const fundingFilterRequired = useMemo(() => d && d.length > 0 && d.find((kpi) => kpi.values.find((v) => v.fundingId)), [d]);

  // #region Обработчик фильтра по годам
  const [selectedYears, setValue] = useState([DEFAULT_YEAR]);
  const handleChange = (e) => {
    const yearValue = parseInt(e.target.value);
    if (selectedYears.includes(yearValue)) {
      setValue(selectedYears.filter((item) => item !== yearValue));
    } else {
      setValue([...selectedYears, yearValue]);
    }
  };

  if (selectedYears.length) {  
    const passByYear = (val, years) => {
      if(years.length === 0) return true;
      const startDate = new Date(val.startDate);
      const endDate = new Date(val.endDate);
      const nowDate = new Date();
      startDate.setHours(0,0,0,0)
      endDate.setHours(0,0,0,0)
      nowDate.setHours(0,0,0,0)
      return years.length === 1 && years[0] === nowDate.getFullYear()
        ? (!val.startDate || startDate.getTime() <= nowDate.getTime()) &&
        (!val.endDate || endDate.getTime() >= nowDate.getTime())
        : (!val.startDate || years.some(year => startDate.getFullYear() <= year)) &&
          (!val.endDate || years.some(year => endDate.getFullYear() >= year));
    }
    d = d.filter(val => passByYear(val, selectedYears));  
  }  

  

  function plansAndFactsRender() {
    // const array = arr.map((item) => [{id: item, title: `План ${2020 + parseInt(item)}`, field: `values[${item}].plan`},{id: item, title:`Факт ${2020 + parseInt(item)}`, field: `values[${item}].fact`}]);
    const array = selectedYears
      .sort((a, b) => a - b)
      .map((item) => [
        {
          id: `${item}plan`,
          title: `План по Программе ${item}`,
          field: 'values',
          render: (rowData) => getFieldRenderFunction(rowData)((getSelectedKpiValue(rowData.values, item) || {}).plan) || '-',
        },
        {
          id: `${item}inner-plan`,
          title: `План максимум ${item}`,
          field: 'values',
          render: (rowData) => getFieldRenderFunction(rowData)((getSelectedKpiValue(rowData.values, item) || {}).planInner) || '-',
          
        },
        // {
        //   id: `${item}estimate`,
        //   title: `Прогноз ${item}`,
        //   field: `values`,
        //   render: rowData => (getSelectedKpiValue(rowData.values, item) || {}).estimate
        // },
        {
          id: `${item}fact`,
          title: `Факт на последнюю отчётную дату`,
          field: 'values',
          render: (rowData) => getFieldRenderFunction(rowData)((getSelectedKpiValue(rowData.values, item) || {}).fact) || '-',
        },
        {
          id: `${item}complete`,
          title: `% выполнения ${item}`,
          field: 'values',
          render: (rowData) => (getSelectedKpiValue(rowData.values, item) || {}).complete,
        },
        {
          id: `${item}reportBosses`,
          title: `Ответственный ${item}`,
          field: 'settings',
          render: (rowData) => (getSelectedSettings(rowData.settings, item) || {}).reportBosses,
        },
      ]);
    const aFlat = array.flat();
    return aFlat;
  }

  // берем только те значения показателя, которые относятся к нужному нам году и типу финансирования
  function getSelectedKpiValue(values, year) {
    const value = values
      .filter((v) => v.year === year && (!fundingFilterRequired || selectedType.includes(v.fundingId)))
      .reduce(
        (acc, curr) => {
          const accProjIds = curr.hasOwnProperty('projIds')
            ? acc.projIds.concat(curr.projIds ?? [])
            : [];
          return (
            {
              ...acc,
              plan: acc.plan || curr.plan
                ? acc.plan + curr.plan
                : '-',
              planInner: acc.planInner || curr.planInner ? acc.planInner + curr.planInner : '-',
              fact: curr.hasOwnProperty('projIds')
                ? new Set(accProjIds).size
                : year === new Date().getFullYear()
                  ? acc.fact || curr[currentPeriod]
                    ? acc.fact + curr[currentPeriod]
                    : null
                  : acc.fact || curr.fact
                    ? acc.fact + curr.fact
                    : null,
              projIds: accProjIds
            });
        },
        { plan: null, planInner: null, fact: null, projIds: [] }
      );
    value.complete = (value.fact || value.fact === 0) && (value.plan && value.plan !== '-') ? (value.fact / value.plan * 100).toFixed(2) + '%' : '-';
    return value
  }
  function getSelectedSettings(settings, year) {
    return settings?.find((v) => v.year === year) || {};
  }

  useEffect(() => {
    const getCurrentPeriod = async () => {
      const periods = await api.get('/mng/kpis/periodFields');
      setCurrentPeriod(periods.find((e) => e.isCurrent).code)
    }
    getCurrentPeriod();
  }, []);

  // useEffect(() => {
  //   d = props.data.filter(val => passByYear(val, selectedYears))
  //   console.log("🚀 ~ useEffect ~ d:", d)
  // }, [props.data, selectedYears]);

  // #endregion

  const columns = [
    {
      title: '№',
      field: 'num',
      type: 'numeric',
      cellStyle: {
        width: '6%',
      },
      render: (row) => (row.num === 'ПРГ2' ? <NavLink to="/indexes/p2p">{row.num}</NavLink> : row.num),
    },
    {
      title: 'Наименование показателя',
      field: 'name',
      cellStyle: {
        width: '60%',
        minWidth: '280px',
      },
      render: (row) => (row.num === 'ПРГ2' ? <NavLink to="/indexes/p2p">{row.name}</NavLink> : row.name),
    },
    // {title: 'Ответственный', field: 'reportBosses'},
    { title: 'Ед.измерения', field: 'unit' },
  ].concat(plansAndFactsRender());

  return (
    <section className="page index-page">
      <div style={styledTable}>
        <MaterialTable
          icons={tableIcons}
          localization={localization}
          columns={columns.map(column => ({...column, hidden: hiddenColumns.includes(column.title)}))}
          data={d}
          title=''
          options={{ paging: false, search : false, columnsButton: true }}
          components={{
            Toolbar: (props) => (
              <div>
                <div className="filters-container">
                  <div className="year-checkboxes">
                    {years.map((year, i) => (
                      <label key={year}>
                        <input
                          type="checkbox"
                          value={year}
                          onChange={handleChange}
                          checked={selectedYears.includes(year)}
                        />
                        <span className="tag">{year}</span>
                      </label>
                    ))}
                  </div>
                  {fundingFilterRequired
                    && (
                      <div className="special-base-checkboxes ms-3">
                        {types.map((item, i) => (
                          <label key={item.num}>
                            <input
                              type="checkbox"
                              id={item.num}
                              value={item.num}
                              checked={selectedType.includes(item.num)}
                              onChange={(event) => event.target.checked ?
                                setIsChecked(prevState => [...prevState, item.num]) :
                                setIsChecked(prevState => prevState.filter(type => type !== item.num))
                              }
                            />
                            <span className="tag">{item.name}</span>
                          </label>
                        ))}
                      </div>
                    )}
                  <div style={{ marginLeft: 'auto' }}>
                    <HideColumnButton
                      columns={props.columns.filter(column => column.id && column.id.endsWith('plan'))}
                      setHiddenColumns={(columnName) => setHiddenColumns(prevState => prevState.includes(columnName) ? prevState.filter(value => value !== columnName) : ([...prevState, columnName]))}
                      show={show}
                      setShow={setShow}
                    />
                  </div>
                </div>
              </div>
            ),
          }}
        />
      </div>
    </section>
  );
}

const styledTable = {
  maxWidth: '100%',
};
